import React from 'react';
import cx from 'classnames';
// components
import renderAsBackgroundImage from '~/libs/server/utils/renderAsBackgroundImage';
import ImageSection from '~/components/ui/ImageSection';
import { bgColorOption } from '~/components/ui/ImageSection/types';
// styles
import imageSectionStyles from '~/components/ui/ImageSection/_imageSection--shared.module.less';
import styles from './ThankYouNoteImageSection.module.less';

const ThankYouNoteImageSection: React.FC = () => {
  const renderText = () => (
    <div className={imageSectionStyles.dek}>
      We’ll help make sure no guest’s generosity goes unnoticed. You can even{' '}
      <a href="/wedding-planning/thank-you-cards/shop" rel="noreferrer noopener">
        shop thank you cards
      </a>{' '}
      here at Zola (and get{' '}
      <a href="/expert-advice/how-to-write-wedding-thank-you-cards" rel="noreferrer noopener">
        tips for writing thoughtful notes
      </a>
      , too).
    </div>
  );
  return (
    <ImageSection
      headerTag="h2"
      backgroundColor={bgColorOption.lightGray}
      title={<div className={imageSectionStyles.title}>Free Thank You Note Manager</div>}
      textPosition="left"
      imageContents={
        <>
          <div className={cx(styles.secondaryImage)}>
            <span role="img" aria-label="custom photo background save the date card" />
          </div>
          {renderAsBackgroundImage({
            selector: `.${styles.secondaryImage}`,
            backgroundImageName: 'registry_benefits_thank_you_note',
            directory: 'WeddingRegistryBenefitsLP/thankYouNote',
            filetype: ['png', 'png', 'png'],
          })}
        </>
      }
      secondaryContents={renderText()}
    />
  );
};

export default ThankYouNoteImageSection;
